/* eslint-disable sonarjs/no-duplicated-branches */
import {
  SHOW_DISCLAIMER,
  FETCH_PROVIDER_PRODUCTS_START,
  FETCH_PROVIDER_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_START,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR,
  FETCH_PRODUCTS_DETAIL_START,
  FETCH_PRODUCTS_DETAIL_SUCCESS,
  FETCH_PRODUCTS_DETAIL_ERROR,
  FETCH_PROVIDER_DETAIL_START,
  FETCH_PROVIDER_DETAIL_SUCCESS,
  FETCH_PROVIDER_DETAIL_ERROR,
  FETCH_PROVIDER_DETAIL_PRODUCT_START,
  FETCH_PROVIDER_DETAIL_PRODUCT_SUCCESS,
  FETCH_PROVIDER_DETAIL_PRODUCT_ERROR,
  FETCH_CATEGORIES_START,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_ERROR,
  FETCH_CATEGORY_PRODUCTS_START,
  FETCH_CATEGORY_PRODUCTS_SUCCESS,
  FETCH_CATEGORY_PRODUCTS_ERROR,
  SEARCH_PRODUCTS_START,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_ERROR,
  CLEAR_SEARCH_VALUE,
  SEARCH_MORE_PRODUCTS_START,
  SEARCH_MORE_PRODUCTS_SUCCESS,
  SEARCH_MORE_PRODUCTS_ERROR,
  UPDATE_SEARCH_VALUE,
  CLEAR_FETCH_PROVIDER_PRODUCTS
} from "actions/marketplaceActions";


const initialState = {
  showDisclaimer: true,
  providerProducts: {
    data: [],
    params: {
      page: 0,
      pageSize: 10,
      searchKey: "",
    },
    showMore: false,
    initRender: true,
  },
  products: {
    data: [],
    params: {
      page: 0,
      pageSize: 5,
      searchKey: "",
    },
    showMore: false,
    initRender: true,
  },
  categories: [],
  categoryProducts: {
    categoryId: "",
    data: [],
    params: {
      page: 0,
      pageSize: 10,
      searchKey: "",
    },
    showMore: false,
  },
  selectedProduct: {},
  selectedProvider: {},
  selectedProviderProducts: [],
  searchResults: {
    data: [],
    params: {
      page: 0,
      pageSize: 10,
      searchKey: "",
    },
    initRender: true,
    showMore: false,
  },
  isFetching: false,
  err: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_DISCLAIMER:
      return {
        ...state,
        showDisclaimer: false,
      };
    case UPDATE_SEARCH_VALUE:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          params: { ...initialState.searchResults.params, searchKey: action.payload },
        },
      };
    case CLEAR_SEARCH_VALUE:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          params: { ...initialState.searchResults.params, searchKey: "" },
        },
      };
    case SEARCH_PRODUCTS_START:
      return {
        ...state,
        searchResults: { ...initialState.searchResults },
        isFetching: true,
        err: "",
      };
    case SEARCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        searchResults: {
          data: [...action.payload.data.products],
          params: {
            ...initialState.searchResults.params,
            searchKey: decodeURIComponent(action.payload.params.searchKey),
            page: action.payload.data.hasMore
              ? state.searchResults.params.page + 1
              : state.searchResults.params.page,
          },
          showMore: action.payload.data.hasMore,
        },
        isFetching: false,
        err: "",
      };
    case SEARCH_PRODUCTS_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
      };
    case SEARCH_MORE_PRODUCTS_START:
      return {
        ...state,
        isFetching: true,
        err: "",
      };
    case SEARCH_MORE_PRODUCTS_SUCCESS:
      return {
        ...state,
        searchResults: {
          data: [...state.searchResults.data, ...action.payload.data.products],
          params: {
            ...initialState.searchResults.params,
            searchKey: action.payload.params.searchKey,
            page: action.payload.data.hasMore
              ? state.searchResults.params.page + 1
              : state.searchResults.params.page,
          },
          showMore: action.payload.data.hasMore,
        },
        isFetching: false,
        err: "",
      };
    case SEARCH_MORE_PRODUCTS_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
      };
    case FETCH_PROVIDER_PRODUCTS_START:
      return {
        ...state,
        isFetching: true,
        err: "",
      };
    case FETCH_PROVIDER_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        providerProducts: {
          data: [...state.providerProducts.data, ...action.payload.data.products],
          params: {
            ...initialState.providerProducts.params,
            page: action.payload.data.hasMore || initialState.providerProducts.initRender
              ? state.providerProducts.params.page + 1
              : state.providerProducts.params.page,
          },
          showMore: action.payload.data.hasMore,
          initRender: false,
        },
      };
      case CLEAR_FETCH_PROVIDER_PRODUCTS:
        return {
          ...state,
          providerProducts: {
            data: [],
            params: {
              page: 0,
              pageSize: 10,
              searchKey: "",
            },
            showMore: false,
            initRender: true,
          },
      };
    case FETCH_PRODUCTS_START:
      return {
        ...state,
        isFetching: true,
        err: "",
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        products: {
          data: [...state.products.data, ...action.payload.data.products],
          params: {
            ...state.products.params,
            page: action.payload.data.hasMore
              ? state.products.params.page + 1
              : state.products.params.page,
          },
          showMore: action.payload.data.hasMore,
          initRender: false,
        },
      };
    case FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
      };
    case FETCH_PROVIDER_DETAIL_PRODUCT_START:
      return {
        ...state,
        isFetching: true,
        err: "",
        selectedProviderProducts: [],
      };
    case FETCH_PROVIDER_DETAIL_PRODUCT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        selectedProviderProducts: action.payload,
      };
    case FETCH_PROVIDER_DETAIL_PRODUCT_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
        selectedProviderProducts: [],
      };
    case FETCH_PROVIDER_DETAIL_START:
      return {
        ...state,
        isFetching: true,
        selectedProvider: {},
        err: "",
      };
    case FETCH_PROVIDER_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        selectedProvider: action.payload,

      };
    case FETCH_PROVIDER_DETAIL_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
        selectedProvider: {},
      };
    case FETCH_PRODUCTS_DETAIL_START:
      return {
        ...state,
        isFetching: true,
        selectedProduct: {},
        err: "",
      };
    case FETCH_PRODUCTS_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        selectedProduct: action.payload,
      };
    case FETCH_PRODUCTS_DETAIL_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
        selectedProduct: {},
      };
    case FETCH_CATEGORIES_START:
      return {
        ...state,
        isFetching: true,
        err: "",
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        categories: [...action.payload],
      };
    case FETCH_CATEGORIES_ERROR:
      return {
        ...state,
        isFetching: false,
        err: action.payload,
      };
    case FETCH_CATEGORY_PRODUCTS_START:
      return {
        ...state,
        isFetching: true,
        categoryProducts:
          state.categoryProducts.categoryId == action.payload.categoryId && action.payload.params
            ? state.categoryProducts
            : initialState.categoryProducts,
        err: "",
      };
    case FETCH_CATEGORY_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        categoryProducts: {
          data: [...state.categoryProducts.data, ...action.payload.data.products],
          categoryId: action.payload.categoryId,
          params: {
            ...initialState.categoryProducts.params,
            page: action.payload.data.hasMore
              ? state.categoryProducts.params.page + 1
              : state.categoryProducts.params.page,
          },
          showMore: action.payload.data.hasMore,
        },
      };
    case FETCH_CATEGORY_PRODUCTS_ERROR:
      return {
        ...state,
        isFetching: false,
        err: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/marketplaceReducer.js